// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-migrate-to-workbook-dialog-body__target-entry {
  margin-top: 12px;
}
.dl-migrate-to-workbook-dialog-body__related-entry {
  margin-bottom: 6px;
}
.dl-migrate-to-workbook-dialog-body__related-entry:last-child {
  margin-bottom: 0;
}
.dl-migrate-to-workbook-dialog-body__alert-info, .dl-migrate-to-workbook-dialog-body__alert-warning {
  margin-top: 12px;
}
.dl-migrate-to-workbook-dialog-body__alert-warning {
  margin-bottom: 12px;
}
.dl-migrate-to-workbook-dialog-body__relations {
  margin-top: 24px;
}
.dl-migrate-to-workbook-dialog-body__relations-groups {
  margin-top: 12px;
}
.dl-migrate-to-workbook-dialog-body__relations-group {
  margin-top: 12px;
}
.dl-migrate-to-workbook-dialog-body__relations-group:first-child {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MigrateToWorkbookDialog/components/Body/Body.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAKI;EAEI,gBAAA;AAJR;AAOI;EACI,mBAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,gBAAA;AAPR;AAUI;EACI,gBAAA;AARR;AAUQ;EACI,aAAA;AARZ","sourcesContent":[".dl-migrate-to-workbook-dialog-body__target-entry {\n  margin-top: 12px;\n}\n.dl-migrate-to-workbook-dialog-body__related-entry {\n  margin-bottom: 6px;\n}\n.dl-migrate-to-workbook-dialog-body__related-entry:last-child {\n  margin-bottom: 0;\n}\n.dl-migrate-to-workbook-dialog-body__alert-info, .dl-migrate-to-workbook-dialog-body__alert-warning {\n  margin-top: 12px;\n}\n.dl-migrate-to-workbook-dialog-body__alert-warning {\n  margin-bottom: 12px;\n}\n.dl-migrate-to-workbook-dialog-body__relations {\n  margin-top: 24px;\n}\n.dl-migrate-to-workbook-dialog-body__relations-groups {\n  margin-top: 12px;\n}\n.dl-migrate-to-workbook-dialog-body__relations-group {\n  margin-top: 12px;\n}\n.dl-migrate-to-workbook-dialog-body__relations-group:first-child {\n  margin-top: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
